var _templateObject;
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }
import { gql } from '@apollo/client';
export default gql(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  mutation LogoutMutation($userId: ID!) {\n    logout(id: $userId) {\n      result\n    }\n  }\n"])));